import 'reflect-metadata';
import {AsyncContainerModule, interfaces} from "inversify";
import {HttpService} from "../httpService";
import {OhMyFetchService} from "../adapters";
import {httpTypes} from "./types";

export default new AsyncContainerModule(async (bind: interfaces.Bind, unbind: interfaces.Unbind) => {
  bind<HttpService>(httpTypes.HttpService).to(OhMyFetchService);
});
